<!-- eslint-disable @angular-eslint/template/elements-content -->
<div
  class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-green-50 dark:from-gray-950 dark:to-green-950 p-4"
>
  <div
    class="w-full max-w-md rounded-xl bg-white dark:bg-gray-900 shadow-lg border border-gray-200 dark:border-gray-800 p-8 space-y-6"
  >
    <div class="text-center space-y-2">
      <h1 class="text-xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'SELECT_BUSINESS.TITLE' | translate }}
      </h1>
      <p class="text-sm text-gray-600 dark:text-gray-400">
        {{ 'SELECT_BUSINESS.SUBTITLE' | translate }}
      </p>
    </div>

    @if (errorMessage) {
      <div
        class="p-3 text-sm rounded-md bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-200"
      >
        {{ errorMessage }}
      </div>
    }

    <div class="space-y-3">
      @for (b of businesses; track b.tenantId) {
        <button
          class="flex items-center gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/80 cursor-pointer"
          (click)="selectedTenantId = b.tenantId"
        >
          <p-radiobutton
            name="tenant"
            [value]="b.tenantId"
            [(ngModel)]="selectedTenantId"
            [inputId]="'t-' + b.tenantId"
          />
          <label [for]="'t-' + b.tenantId" class="text-sm font-medium cursor-pointer flex-1">
            {{ b.businessName }}
          </label>
        </button>
      }
    </div>

    <button
      type="button"
      pButton
      class="w-full"
      [loading]="loading"
      [disabled]="loading || !selectedTenantId"
      [label]="'SELECT_BUSINESS.CONTINUE' | translate"
      (click)="submit()"
    ></button>
  </div>
</div>
